import {useState} from 'react';
//import { Route, NavLink, HashRouter } from "react-router-dom";

import './App.css';
import ProjectPage from './Components/Projects/ProjectPage';
import ArtPage from './Components/Art/ArtPage';
import Navigation from './Components/Navigation';
import Footer from './Components/Footer';
import AboutPage from './Components/About/AboutPage';
import Resume from './Components/Resume/Resume';

let currentPage = window.location.hash;

function App() {
  const [tabClicked, setPage] = useState(false);

  const onTabClicked = (pageLink) => {
    currentPage = pageLink;
    setPage((tabClicked) => !tabClicked);
  }

  return (
    <>
      <div name="header image" className="row text-center TopSeperator"><img className="header-image" src="/images/site_banner.png"/></div>
      <Navigation onTabClicked={onTabClicked}/>
      <div name="content body" className="content-body TopSeperator">

        {currentPage == "" && <ProjectPage/>}
        {currentPage == "#/art" && <ArtPage/>}
        {currentPage == "#/work" && <ProjectPage/>}
        {currentPage == "#/about" && <AboutPage/>}
        {currentPage == "#/resume" && <Resume/>}
        <Footer onTabClicked={onTabClicked}/>
      </div>
    </>
  );
}

export default App;
